// Libraries
import { Image, Title, Container, Menu, Group, Divider, Text } from '@mantine/core';
import { useNavigate, useLocation } from 'react-router-dom';


// Components
//import Status from '../status/Status';

// Styles
import styles from './Navbar.module.css';

// Images
import personalLogo from '@/assets/newLogo.png';
import { FiChevronDown } from 'react-icons/fi';

export function Navbar({expiryBanner} : {expiryBanner : boolean} ) {

    const navigate = useNavigate();
    const location = useLocation();

    const menuOptions = [
        {
            name: 'Working at TDS',
            pathname: '/career',
            key: 'career',
            color: 'var(--teal-tint)'
        },
        {
            name: 'Books',
            pathname: '/books',
            key: 'books',
            color: 'var(--blue-tint)'
        },
        {
            name: 'Mountains',
            pathname: '/mountains',
            key: 'mountains',
            color: 'var(--purple-tint)'
        },
        {
            name: 'Projects',
            pathname: '/projects',
            key: 'projects',
            color: 'var(--orange-tint)'
        },
    ];

    return (
        <Container size='sm' h='100%'>
            <div className={`${styles.navInterior} ${expiryBanner ? styles.expiry : ''}`}>

                <Group>
                <div className={styles.personalLogo} onClick={() => navigate('/home')} >
                    <Image src={personalLogo} h='40px' />
                    <Title ff='josefin sans variable' fw={600} fz={22} ml={10} mt={6}>TOM HERREN</Title>
                </div>

                    <Menu shadow="md" width={200} trigger='click' radius="md" position='bottom-start'>
                        <Menu.Target>
                            <div className={styles.trigger}>
                                <Divider orientation='vertical' size='xs' className={styles.divider} color='#8c99a6'/>
                                <Text className={styles.pathname}>{location.pathname.split('/')[1]}</Text>
                                <FiChevronDown />
                            </div>
                        </Menu.Target>
                        <Menu.Dropdown bg='var(--blue-shade-max)'>
                            {menuOptions.map((option) => (
                            <Menu.Item
                                key={option.key}
                                onClick={() => navigate(option.pathname)}
                                className={styles.pageLink}
                            >
                                <Text ff='Geist Mono' fz={18} fw={500} c={option.color}>
                                    {option.name}
                                </Text>
                            </Menu.Item>
                        ))}
                        </Menu.Dropdown>
                    </Menu>
                    {/*<Image src={crowText} h='28px' />*/}
                </Group>
                {/*<div className={styles.navbarRight}>
                    <Status />
                </div>*/}
            </div>
        </Container>
    );
}

export default Navbar;
